import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { FacultyModel } from '../../model/faculty.model';
import { FacultyFellowshipSpecialisationModel } from '../../model/faculty_fellowship_specialisation.model';
import { FacultyMedicalProcedureModel } from '../../model/faculty_medical_procedure.model';
import { FacultyMedicalProcedureCategoryModel } from '../../model/faculty_medical_procedure_category.model';
import { FacultyMedicalProcedureService } from '../../providers/faculty_medical_procedure.service';
import { SuccessSnackbarComponent } from '../success-snackbar/success-snackbar.component';

@Component({
  selector: 'app-fellowship-procedures-edit-dialog',
  templateUrl: './fellowship-procedures-edit-dialog.component.html',
  styleUrls: ['./fellowship-procedures-edit-dialog.component.css']
})
export class FellowshipProceduresEditDialogComponent implements OnInit {

  // mFacultyFellowshipSpecialisations:FacultyFellowshipSpecialisationModel[]= new FacultyFellowshipSpecialisationModel();

  // mFacultyFellowshipSpecialisations: Array<FacultyFellowshipSpecialisationModel> = [];
  newItem: FacultyMedicalProcedureModel;
  selectedItem: FacultyMedicalProcedureModel;
  mFacultyMedicalProcedureCategories: FacultyMedicalProcedureCategoryModel[];
  isFellowshipProcedure: boolean;
  mItems: FacultyMedicalProcedureModel[] = [];
  mFellowshipItems: FacultyMedicalProcedureModel[] = [];
  mMembershipItems: FacultyMedicalProcedureModel[] = [];
  mFaculty: FacultyModel;
  durationInSeconds = 1;
  errorMessage: string = '';
  isLoading: boolean = true;


  mCategorisedFacultyMedicalProcedureCategories: FacultyMedicalProcedureCategoryModel[];
  selected: FacultyMedicalProcedureModel;

  constructor(private fb: FormBuilder, private mApiService: FacultyMedicalProcedureService,private _snackBar: MatSnackBar,
    private dialogRef: MatDialogRef<FellowshipProceduresEditDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { 
      this.mFaculty = new FacultyModel();
    }

  onNoClick(): void {
    this.dialogRef.close();
  }

  ngOnInit(): void {
    this.isFellowshipProcedure = (this.data.ProgramCategoryId == 1) ? true : false;
    this.selectedItem = this.data;
  
  }

  resetProcedureCategory(event: Event): void {

    if (this.newItem != null)
      this.newItem.CategoryId = null;
    if (this.selectedItem != null) {
      // console.log(event.target);
      this.selectedItem.CategoryId = null;
    }

  }

  getProcedureCategories(fellowshipSpecialtyId: string): FacultyMedicalProcedureCategoryModel[] {
    if (this.isFellowshipProcedure) {
      if (fellowshipSpecialtyId == null)
        return []

      return this.mCategorisedFacultyMedicalProcedureCategories?.filter(k => k?.FellowshipSpecialisationId == fellowshipSpecialtyId);

    }
    else {
      return this.mCategorisedFacultyMedicalProcedureCategories;
    }

  }


  
  saveEdit() {



    console.log(this.selectedItem);

    this.mApiService
      .editItem(this.selectedItem)
      .subscribe(
        p => {

          this.dialogRef.close() ;
          
          this._snackBar.openFromComponent(SuccessSnackbarComponent, {
           duration: this.durationInSeconds * 1000,
         });
          this.getItemsList(this.mFaculty.Id);
        },
        e => this.errorMessage = e,
        () => this.isLoading = false
      )

  }

  getItemsList(id: string) {
    this.mItems = [];
    this.isLoading = true;


    this.mApiService.getItems(id, 0)
      .subscribe(
        p => {

          this.mItems = p;
          this.categoriseItems();

        },
        e => this.errorMessage = e,
        () => this.isLoading = false
      )

  }

  categoriseItems(): any {
    this.mFellowshipItems = this.mItems.filter(item => item.ProgramCategoryId == 1);
    this.mMembershipItems = this.mItems.filter(item => item.ProgramCategoryId == 2);
  }

}
